/**
 * @returns `current / previous`, or `1` when only the current value is positive, otherwise `0`.
 */
export function getTrend(current?: number, previous?: number) {
  if (current && previous && previous > 0) return current / previous
  return current && current > 0 ? 1 : 0
}

/**
 * @returns The trend between two averages, or `0` when either period has no samples.
 */
export function getAverageTrend({ current, previous }: { current: number | null; previous: number | null }) {
  if (current === null || previous === null) return 0
  return getTrend(current, previous)
}
